"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultComponents = exports.Step = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
var overrides_1 = require("../../util/overrides");
var VFlow_1 = require("../VFlow");
var useMeasure_1 = require("../../hooks/useMeasure");
var useStepperContext_1 = require("./useStepperContext");
var StepConnector_1 = require("./StepConnector");
var StepContent_1 = require("./StepContent");
var StepLabel_1 = require("./StepLabel");
var StepIcon_1 = require("./StepIcon");
function Step(props) {
    var _a = props.status, status = _a === void 0 ? 'incompleted' : _a, title = props.title, subtitle = props.subtitle, overrides = props.overrides, children = props.children, style = props.style, rest = __rest(props, ["status", "title", "subtitle", "overrides", "children", "style"]);
    var Root = overrides_1.getComponents(overrides, exports.defaultComponents).Root;
    var _b = useStepperContext_1.useStepperContext(), direction = _b.direction, getNextStepStatus = _b.getNextStepStatus, incrementStep = _b.incrementStep;
    var _c = styles_1.useStyles(function () { return createStyles(direction); }), classes = _c.classes, css = _c.css;
    var _d = useMeasure_1.useHeight(), labelRef = _d[0], labelHeight = _d[1];
    var _e = react_1.useState(null), stepIndex = _e[0], setStepIndex = _e[1];
    var nextStepStatus = getNextStepStatus(stepIndex);
    var isLastStep = nextStepStatus === undefined;
    react_1.useEffect(function () {
        var index = incrementStep();
        setStepIndex(index);
    }, [incrementStep]);
    if (stepIndex === null) {
        return null;
    }
    return (react_1.default.createElement(Root, __assign({ className: css(classes.step, style) }, rest),
        !isLastStep && react_1.default.createElement(StepConnector_1.StepConnector, { status: nextStepStatus, direction: direction, labelHeight: labelHeight }),
        react_1.default.createElement(VFlow_1.VFlow, { vSpacing: 0 },
            react_1.default.createElement("div", { className: classes.labelContainer, ref: labelRef },
                react_1.default.createElement(StepIcon_1.StepIcon, { status: status, icon: overrides === null || overrides === void 0 ? void 0 : overrides.Icon }),
                react_1.default.createElement(StepLabel_1.StepLabel, { status: status, title: title, subtitle: subtitle })),
            children && react_1.default.createElement(StepContent_1.StepContent, null, children))));
}
exports.Step = Step;
exports.defaultComponents = {
    Root: 'span',
    Icon: null,
};
var createStyles = function (direction) {
    var isHorizontal = direction === 'horizontal';
    return {
        step: {
            position: 'relative',
            textAlign: isHorizontal ? 'center' : 'start',
        },
        labelContainer: {
            display: 'flex',
            flexDirection: isHorizontal ? 'column' : 'row',
            alignItems: 'center',
            gap: isHorizontal ? '0.75rem' : '0.5rem',
        },
    };
};
//# sourceMappingURL=Step.js.map